<template>
    <v-form class="px-2"
            ref="form"
            lazy-validation
            v-model="isFormValid"
            @submit.prevent="">
        <v-row>
            <v-col cols="12" class="pb-2 pt-3">
                <v-text-field :placeholder="$t('login.fullName')"
                              hide-details
                              v-model="name"
                              solo
                              style="color: #172B4D;"
                              @keyup.enter="submit()">
                    <template slot="prepend-inner">
                        <v-icon color="#172B4D">
                            mdi-account-outline
                        </v-icon>
                    </template>
                </v-text-field>
            </v-col>

            <v-col cols="12" class="pb-2">
                <country-picker solo v-model="country"/>
            </v-col>

            <v-col cols="12" class="pb-2">
                <v-text-field :placeholder="$t('login.phone')"
                              :disabled="isInvited && invitationData.phone !== ''"
                              hide-details
                              v-model="phone"
                              solo
                              @keyup.enter="submit()">
                    <v-row class="fill-height"  align="center" slot="prepend-inner">
                        <v-icon class="pl-4"
                                color="#172B4D">
                            fas fa-mobile-alt
                        </v-icon>
                        <div class="pl-2 pr-3 grey--text">+{{country.number || '1'}}</div>
                    </v-row>
                </v-text-field>
            </v-col>

            <v-col cols="12" class="pb-2">
                <v-text-field :placeholder="$t('login.email')"
                              :disabled="isInvited && invitationData.email !== ''"
                              hide-details
                              v-model="email"
                              solo
                              @keyup.enter="submit()">
                    <template slot="prepend-inner">
                        <v-icon color="#172B4D">
                            mdi-email-outline
                        </v-icon>
                    </template>
                </v-text-field>
            </v-col>

            <v-col cols="12" class="pb-2">
                <v-text-field :placeholder="$t('login.password')"
                              type="password"
                              hide-details
                              v-model="password"
                              solo
                              @keyup.enter="submit()">
                    <template slot="prepend-inner">
                        <v-icon color="#172B4D">
                            feather-lock
                        </v-icon>
                    </template>
                </v-text-field>
            </v-col>

            <v-col cols="12" class="pt-2">
                <div class="d-flex align-start">
                    <div class="kb-login-checkbox"
                         @click="habeasData = true"
                         v-show="!habeasData"/>
                    <v-icon @click="habeasData = false"
                            class="ma-0 pa-0"
                            color="kbDarkBlue"
                            size="30px"
                            v-show="habeasData">
                        mdi-checkbox-marked
                    </v-icon>
                    <span class="ml-1"
                          style="color: #172B4D;
                                 font-size: 14px;
                                 font-weight: 400;
                                 text-align: center;">
                        {{ $t('login.iAgree') }}
                        <a class="font-weight-regular"
                           href="https://keybe.ai/privacidad/"
                           style="color: #11CDEF; cursor: pointer; text-decoration: none;"
                           target="_blank">
                            {{ $t('login.termsAndConditions') }}
                        </a>
                    </span>
                </div>
            </v-col>

            <v-col class="pt-0 mb-1 text-center" cols="12" >
                <v-btn color="#11CDEF"
                       dark
                       height="40px"
                       :loading="loading"
                       @click="submit()"
                       style="font-size: 16px">
                    {{ $t('login.signUp') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import countries from '@/libs/countries'
import authService from '@/services/authService'
import CountryPicker from '@/components/ui/CountryPicker.vue'
import validations from '../../libs/validations'
export default {
  components: { CountryPicker },
  computed: {
    invitation () {
      return this.$route.query.invitation
    }
  },
  created () {
    this.checkIfUserIsInvited()
  },
  data: () => ({
    isFormValid: false,
    loading: false,
    country: '',
    name: '',
    phone: '',
    email: '',
    password: '',
    registerWithPhone: false,
    isInvited: false,
    invitationData: {},
    habeasData: false
  }),
  methods: {
    async checkIfUserIsInvited () {
      try {
        if (this.invitation) {
          const response = await authService.getDataFromTheInvitation(this.invitation)
          this.invitationData = response
          const country = countries.find(country => {
            return country.code === response.country.toLowerCase()
          })
          this.country = country || { country: 'Colombia', code: 'co', number: '57' }

          this.phone = response.phone
          this.email = response.email
          this.isInvited = true
          return true
        }
      } catch (e) {
        this.isInvited = false
        console.error(e)
        throw e
      }
    },
    submit () {
      if (!validations.register({
        name: this.name,
        email: this.email,
        country: this.country.code,
        phone: this.phone,
        password: this.password,
        habeasData: this.habeasData
      })) return
      this.loading = true
      this.isInvited ? this.registerEmailInvitation() : this.register()
    },
    async register () {
      try {
        await this.$store.dispatch('register', {
          name: this.name,
          email: this.email,
          country: this.country.code,
          phone: this.phone,
          password: this.password
        })
        this.loading = false
      } catch (e) {
        this.loading = false
        console.error(e)
      }
    },
    async registerEmailInvitation () {
      try {
        await this.$store.dispatch('registerEmailInvitation', {
          email: this.email,
          password: this.password,
          phone: this.phone,
          name: this.name,
          invitationCode: this.invitation
        })
        this.loading = false
      } catch (e) {
        this.loading = false
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
    .kb-login-checkbox {
        width: 25px;
        height: 22px;
        cursor: pointer;
        background-color: white;
        border-radius: 2px;
        box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2);
    }
    ::v-deep button.v-icon.notranslate.v-icon--link.mdi.mdi-checkbox-marked.theme--light {
        align-items: start!important;
    }
    ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
        box-shadow: 0 2px 4px rgba(23, 23, 23, 0.18);
        text-decoration: none!important;
    }
    ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot input {
        border-bottom: none!important;
    }
</style>
